import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const Reference = () => {
  const { t } = useTranslation();

  return (
    <div className="text-white">
      <ReactMarkdown
        components={{
          h1: ({ node, children, ...props }) => <h1 className="text-3xl font-bold mb-4 mt-6" {...props}>{children}</h1>,
          h2: ({ node, children, ...props }) => <h2 className="text-2xl font-semibold mb-3 mt-5" {...props}>{children}</h2>,
          p: ({ node, ...props }) => <p className="mb-4" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc list-inside mb-4" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal list-inside mb-4" {...props} />,
          li: ({ node, ...props }) => <li className="mb-1" {...props} />,
        }}
      >
        {t('reference.content')}
      </ReactMarkdown>
    </div>
  );
};

export default Reference;